import { Platform } from "../constants";

import { SetupSection } from "./components/setup-section";
import { Code, OrderedList, SubSubSectionHeader } from "./components/styled";
import { URLVerification, UtmParamsClipboard } from "./components/utms";
import { VideoContent } from "./components/video-content";
import { type PlatformDetails } from "./platform-details";

const PLATFORM = Platform.GOOGLE;

export const GoogleDetails: PlatformDetails = {
  northbeamDocUrl:
    "https://docs.northbeam.io/docs/setting-up-google-ads-for-northbeam",
  officialDocUrl: "",
  additionalDetails: [
    {
      title: "Google Ads includes the following advertising channels",
      content: (
        <OrderedList variant="disc">
          <>Search</>
          <>YouTube</>
          <>Gmail</>
          <>Maps</>
          <>Display</>
          <>Discovery</>
          <>Shopping</>
        </OrderedList>
      ),
    },
    {
      title: "What does the native integration do?",
      /* eslint-disable max-len */
      content:
        "Northbeam natively integrates with the Google Ads API. By doing so, we pull all your current and historical Campaigns, Adsets, and Ads from your account, along with a list of useful metrics. Notably, we pull impressions, which fuel our view model and unlock our Clicks + Modeled Views attribution model. We also pull ad spend to help you with decision making.",
    },
  ],
};

export const GoogleSetup = ({
  connectionContent,
}: {
  connectionContent: React.ReactNode;
}) => (
  <>
    <SetupSection title="Log into Google Ads to connect integration">
      {connectionContent}
    </SetupSection>
    <SetupSection title="Copy these UTM parameters into your Google Ads">
      <VideoContent
        title="Learn how to structure Google UTMs test"
        platform={PLATFORM}
        videoUrl="https://www.loom.com/embed/8af9854ac3de4f4696cb7f6c595ef090?sid=55f07dff-fd0c-4ab6-8142-1fcbd1c1b77d"
      />
      <div>
        <SubSubSectionHeader>
          Make sure you’ve followed these steps:
        </SubSubSectionHeader>
        <OrderedList className="mt-2">
          <div className="inline space-x-2">
            <span>
              You will only need to set your UTM tracking parameters in the
            </span>
            <Code>Final URL Suffix</Code>
            <span>at the</span>
            <Code>Account level</Code>
            <span>for Google Ads</span>
          </div>
          <>
            <div className="inline space-x-2">
              <span>
                If you have any existing parameters at a lower level (e.g.
              </span>
              <Code>Campaign</Code>
              <span>,</span>
              <Code>Ad group</Code>
              <span>, or</span>
              <Code>Ad</Code>
              <span>
                ) those will take priority over the account level. There are two
                possible solutions:
              </span>
            </div>
            <OrderedList variant="disc" indent={1}>
              <>Move our parameters down to the lower level.</>
              <>Move existing parameters up to the account level.</>
            </OrderedList>
          </>
        </OrderedList>
      </div>
    </SetupSection>
    <SetupSection title="Copy UTM parameters into Google Ads">
      <UtmParamsClipboard platform={PLATFORM} />
    </SetupSection>
    <URLVerification platform={PLATFORM} />
  </>
);
